import React from 'react';
import styles from './components.module.css';

export interface LoadingProps {
  text?: string;
}

export const Loading: React.FC<LoadingProps> = ({ text = 'Carregando...' }) => {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.spinner} />
      {text && <p className={styles.loadingText}>{text}</p>}
    </div>
  );
};

export default Loading;
